import { createContext } from 'react';
const MailDocumentationContext = createContext();
export default MailDocumentationContext;
